"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionData = void 0;
var SessionData = (function () {
    function SessionData() {
        this.data = {
            gameSession: NaN,
            friends: []
        };
    }
    SessionData.prototype.init = function (session) {
        this.data.gameSession = (parseInt(session === null || session === void 0 ? void 0 : session.gameSession, 10) || 0) + 1;
        this.data.friends = (session === null || session === void 0 ? void 0 : session.friends) || [];
        return this.getRawData();
    };
    SessionData.prototype.getRawData = function () {
        return this.data;
    };
    Object.defineProperty(SessionData.prototype, "ftue", {
        get: function () {
            return this.data.gameSession <= 1;
        },
        enumerable: false,
        configurable: true
    });
    return SessionData;
}());
exports.SessionData = SessionData;
//# sourceMappingURL=SessionData.js.map